import { useSelector } from 'react-redux';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { MAX_ATTACHMENTS, MAX_ATTACHMENTS_CORE } from '../constants';

export function useMaxAttachmentsAllowed() {
  const hasCoreMembership = useSelector(getCurrentUserHasCore);
  if (hasCoreMembership) {
    return MAX_ATTACHMENTS_CORE;
  }
  return MAX_ATTACHMENTS;
}

export default useMaxAttachmentsAllowed;
